// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/left_stars.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/right_stars.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FreemiumComponents_page-title__tD4RI {
  align-self: flex-start;
  margin-bottom: 28px;
}
.FreemiumComponents_page-title__tD4RI:has(+ .FreemiumComponents_subtitle__3sD2O) {
  margin-bottom: 0;
}

.FreemiumComponents_subtitle__3sD2O {
  font-size: 20px;
  line-height: 36px;
  margin-bottom: 28px;
  color: #00007a;
}

.FreemiumComponents_shining_title__mvRtf {
  width: min-content;
  max-width: calc(100% - 50px);
  font-size: 44px;
  font-weight: 500;
  text-align: center;
  hyphens: auto;
  position: relative;
}
.FreemiumComponents_shining_title__mvRtf.FreemiumComponents_max__vvlDJ {
  width: fit-content;
}
.FreemiumComponents_shining_title__mvRtf::before, .FreemiumComponents_shining_title__mvRtf::after {
  position: absolute;
}
.FreemiumComponents_shining_title__mvRtf::before {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  top: -5px;
  left: -23px;
}
.FreemiumComponents_shining_title__mvRtf::after {
  content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  top: -18px;
  right: -23px;
}

.FreemiumComponents_required__4YHpB {
  color: #00007a;
  font-size: 10px;
  margin-top: 20px;
}

.FreemiumComponents_form__VQNUp {
  width: 100%;
}
.FreemiumComponents_form__VQNUp > div:not(:first-child) {
  margin-top: 20px;
}

.FreemiumComponents_checkbox__73rhH label {
  font-size: 14px;
  font-weight: 400;
}

.FreemiumComponents_button__CPcuJ {
  width: 200px;
  display: block;
  margin: 50px auto;
}

@media screen and (max-width: 600px) {
  .FreemiumComponents_inputs__POW9v {
    margin-bottom: 32px;
  }
  .FreemiumComponents_button__CPcuJ {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/FreemiumComponents.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAMA;EACE,sBAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cCZS;ADYX;;AAGA;EACE,kBAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AAAF;AAEE;EACE,kBAAA;AAAJ;AAGE;EACE,kBAAA;AADJ;AAIE;EACE,gDAAA;EACA,SAAA;EACA,WAAA;AAFJ;AAKE;EACE,gDAAA;EACA,UAAA;EACA,YAAA;AAHJ;;AAOA;EACE,cC9CS;ED+CT,eAAA;EACA,gBAAA;AAJF;;AAWA;EACE,WAAA;AARF;AAUE;EACE,gBAAA;AARJ;;AAYA;EACE,eAAA;EACA,gBAAA;AATF;;AAYA;EACE,YAAA;EACA,cAAA;EACA,iBAAA;AATF;;AAgBA;EACE;IACE,mBAAA;EAbF;EAgBA;IACE,WAAA;EAdF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n\n// Fonts\n\n.page-title {\n  align-self: flex-start;\n  margin-bottom: 28px;\n\n  &:has(+.subtitle){\n    margin-bottom: 0;\n  }\n}\n\n.subtitle {\n  font-size: 20px;\n  line-height: 36px;\n  margin-bottom: 28px;\n  color: colors.$primary8;\n}\n\n.shining_title{\n  width: min-content;\n  max-width: calc(100% - 50px);\n  font-size: 44px;\n  font-weight: 500;\n  text-align: center;\n  hyphens: auto;\n  position: relative;\n\n  &.max{\n    width: fit-content;\n  }\n\n  &::before, &::after{\n    position: absolute;\n  }\n\n  &::before{\n    content: url(../../assets/left_stars.svg);\n    top: -5px;\n    left: -23px;\n  }\n\n  &::after{\n    content: url(../../assets/right_stars.svg);\n    top: -18px;\n    right: -23px;\n  }\n}\n\n.required{\n  color: colors.$primary8;\n  font-size: 10px;\n  margin-top: 20px;\n}\n\n\n\n// Forms\n\n.form{\n  width: 100%;\n\n  > div:not(:first-child) {\n    margin-top: 20px;\n  }\n}\n\n.checkbox label{\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.button{\n  width: 200px;\n  display: block;\n  margin: 50px auto;\n}\n\n\n\n// Responsive\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .inputs {\n    margin-bottom: 32px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"page-title": `FreemiumComponents_page-title__tD4RI`,
	"subtitle": `FreemiumComponents_subtitle__3sD2O`,
	"shining_title": `FreemiumComponents_shining_title__mvRtf`,
	"max": `FreemiumComponents_max__vvlDJ`,
	"required": `FreemiumComponents_required__4YHpB`,
	"form": `FreemiumComponents_form__VQNUp`,
	"checkbox": `FreemiumComponents_checkbox__73rhH`,
	"button": `FreemiumComponents_button__CPcuJ`,
	"inputs": `FreemiumComponents_inputs__POW9v`
};
export default ___CSS_LOADER_EXPORT___;
